import CheckMail from '../Action/ActionTypes/CheckMail';
import LoaderType from '../Action/ActionTypes/LoaderType';
import LogoutUser from '../Action/ActionTypes/LogoutTypes';
import RefreshToken from '../Action/ActionTypes/RefreshToken';

const initialState = {
  isAuthorised: null,
  signUp: '',
  signIn: '',
  loading: false,
  isConflict: false,
  userExists: false,
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'signUp':
      return { ...state, signUp: action.payload, isConflict: action.conflict };
    case CheckMail.CHECK_MAIL_SUCCESS:
      return { ...state, userExists: action.payload };
    case 'signIn':
      return {
        ...state,
        signIn: action.payload,
        isAuthorised: action.isAuthorised,
      };
    case LoaderType.SET_LOADER_TRUE:
      return { ...state, loading: true };
    case LoaderType.SET_LOADER_FALSE:
      return { ...state, loading: false };
    case RefreshToken.REFRESH_TOKEN_SUCCESS:
      return { ...state, signIn: action.payload, isAuthorised: true };
    default:
      return state;
  }
};

export default AuthReducer;
